import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import css from './DailyBonusesCards.module.css';

import { ActionsCard } from 'v2/components/actionsCard/ActionsCard';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';

export interface DailyBonusesCardItem {
  id: string;
  label: string;
}

export interface DailyBonusesCardsProps {
  items: DailyBonusesCardItem[];
  cardsTitle: string;
  openEditModal: (id: string) => void;
  openDeleteModal: (id: string) => void;
  isItemsLoading: boolean;
  deleteConfirmationMessage?: string;
}

export const DailyBonusesCards: FC<DailyBonusesCardsProps> = ({
  items,
  cardsTitle,
  openEditModal,
  openDeleteModal,
  isItemsLoading,
  deleteConfirmationMessage,
}) => (
  <Box className={css.dailyBonusesCardsContainer}>
    <Typography fontSize="18px" fontWeight="600">
      {cardsTitle}
    </Typography>
    {!isItemsLoading ? (
      <>
        {items.length === 0 ? (
          <EmptyPlaceholder text="There is no item. Please add the first one." />
        ) : (
          <Box className={css.dailyBonusesCards}>
            {items.map((item) => {
              const { label, id } = item;

              const handleOpenEditModal = () => openEditModal(id);
              const handleOpenDeleteModal = () => openDeleteModal(id);

              return (
                <ActionsCard
                  key={id}
                  label={label}
                  openDeleteModal={handleOpenDeleteModal}
                  openEditModal={handleOpenEditModal}
                  deleteConfirmationMessage={deleteConfirmationMessage}
                />
              );
            })}
          </Box>
        )}
      </>
    ) : (
      <Box display="flex" justifyContent="center" width="100%" padding="20px 0">
        <Loader />
      </Box>
    )}
  </Box>
);
